// Authentication actions types
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR_CLEAR = 'AUTH_ERROR_CLEAR';
export const AUTH_SET_AUTO_FAIL = 'AUTH_SET_AUTO_FAIL';
export const AUTH_SET_CREDENTIALS = 'AUTH_SET_CREDENTIALS';
export const AUTH_SET_USER_INFO = 'AUTH_SET_USER_INFO';
export const AUTH_PHONE_NUMBER_NOT_VERIFIED = 'AUTH_PHONE_NUMBER_NOT_VERIFIED';
export const AUTH_PHONE_NUMBER_VERIFIED = 'AUTH_PHONE_NUMBER_VERIFIED';
export const AUTH_SET_REQUESTED_PATH = 'AUTH_SET_REQUESTED_PATH';
export const AUTH_SET_PENDING_APPROVALS = 'AUTH_SET_PENDING_APPROVALS';
export const AUTH_SET_SELECTED_ORGANIZATION = 'AUTH_SET_SELECTED_ORGANIZATION';
export const AUTH_BANK_ID_NOT_VERIFIED = 'AUTH_BANK_ID_NOT_VERIFIED';

// User group action types
export const USER_GROUPS_REQUEST_START = 'USER_GROUPS_REQUEST_START';
export const USER_GROUPS_GET_SUCCESS = 'USER_GROUPS_GET_SUCCESS';
export const USER_GROUPS_REQUEST_ERROR = 'USER_GROUPS_REQUEST_ERROR';
export const USER_GROUP_ADD_EMPTY_GROUP = 'USER_GROUP_ADD_EMPTY_GROUP';
export const USER_GROUP_DELETE_GROUP = 'USER_GROUP_DELETE_GROUP';
export const USER_GROUP_UPDATE_GROUP = 'USER_GROUP_UPDATE_GROUP';
export const USER_GROUP_SELECT_GROUP = 'USER_GROUP_SELECT_GROUP';
export const USER_GROUP_SELECTED_CLEAR = 'USER_GROUP_SELECTED_CLEAR';

// User action types
export const USERS_REQUEST_START = 'USERS_REQUEST_START';
export const USERS_REQUEST_USERS_ERROR = 'USERS_REQUEST_USERS_ERROR';
export const USERS_UPDATE_USER = 'USERS_UPDATE_USER';
export const USERS_ADD_USER = 'USERS_ADD_USER';
export const USERS_DELETE_USER = 'USERS_DELETE_USER';
export const USERS_DELETE_SAVED_USER = 'USERS_DELETE_SAVED_USER';
export const USERS_GET_USERS_SUCCESS = 'USERS_GET_USERS_SUCCESS';
export const USERS_GET_USERGROUP_USERS_SUCCESS = 'USERS_GET_USERGROUP_USERS_SUCCESS';

// Notification action types
export const SHOW_GROWL_NOTIFICATION = 'SHOW_GROWL_NOTIFICATION';
export const SHOW_GROWL_NOTIFICATION_TRANSLATED = 'SHOW_GROWL_NOTIFICATION_TRANSLATED';
export const CLOSE_GROWL_NOTIFICATION = 'CLOSE_GROWL_NOTIFICATION';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_CLOSE = 'MODAL_CLOSE';

// Shop action types
export const SHOP_REQUEST_START = 'SHOP_REQUEST_START';
export const SHOP_SET_PRODUCT = 'SHOP_SET_PRODUCT';
export const SHOP_SET_DELIVERY_DETAILS = 'SHOP_SET_DELIVERY_DETAILS';
export const SHOP_PURCHASE_SUCCESS = 'SHOP_PURCHASE_SUCCESS';
export const SHOP_REQUEST_FAILED = 'SHOP_REQUEST_FAILED';
export const SHOP_RESET_SHOP = 'SHOP_RESET_SHOP';
export const SHOP_SET_ORDER_RESP = 'SHOP_SET_ORDER_RESP';
export const SHOP_RESET_ORDER_AND_DELIVERY = 'SHOP_RESET_ORDER_AND_DELIVERY';
export const SHOP_RESET_PRODUCT = 'SHOP_RESET_PRODUCT';
export const SHOP_SET_ORDER_FOR_ORGANIZATION = 'SHOP_SET_ORDER_FOR_ORGANIZATION';
export const SHOP_CLEAR_ORDER_FOR_ORGANIZATION = 'SHOP_CLEAR_ORDER_FOR_ORGANIZATION';
export const SHOP_SET_ORDER_ON_BEHALF_PENDING_USER_SELECTION = 'SHOP_SET_ORDER_ON_BEHALF_PENDING_USER_SELECTION';
export const SHOP_CLEAR_ORDER_ON_BEHALF_PENDING_USER_SELECTION = 'SHOP_CLEAR_ORDER_ON_BEHALF_PENDING_USER_SELECTION';
export const SHOP_SET_ORDER_ON_BEHALF_USER = 'SHOP_SET_ORDER_ON_BEHALF_USER';
export const SHOP_CLEAR_ORDER_ON_BEHALF_USER = 'SHOP_CLEAR_ORDER_ON_BEHALF_USER';

// Feature flags
export const FEATURE_FLAGS_SET = 'FEATURE_FLAGS_SET';
